angular.module('app').directive('trsResFilterPanel', function(){
    return {
        scope: true,
        restrict: 'AE',
        templateUrl: './resourceCenter/directive/resFilterPanel/resFilterPanel.html',
        transclude:{
            'constom': '?constom',
            'moreLeft': '?moreLeft',
        },
        replace: true,
        link: function($scope, iElm, iAttrs, controller) {
            initStatus();

            /**
             * 初始化状态
             */
            function initStatus(){

            }
        }
    };
});
